import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateConfig,
} from "../../../store/slices/HomeVideos/homeVideosSlice.js";
import { useGetListDataQuery, useUpdateStatusByIdMutation } from "../../../store/queries/homeVideos";

const useHomeVideos = (dashboard) => {
  const dispatch = useDispatch();
  const menuState = useSelector((state) => state.homeVideo);
  const [skip, setSkip] = useState(true);

  const { showEditModal } = useSelector((state) => state.homeVideo);

  const {
    data: mainData = {},
    isFetching,
    isLoading,
    refetch,
  } = useGetListDataQuery({
    id: 1
  });

  const [updateStatus] = useUpdateStatusByIdMutation();

  if(mainData) {
    dispatch(
      updateConfig((state) => {
        state.selectedItemsDetails = mainData?.data;
      })
    );
  }

  useEffect(() => {
    if (menuState.clearSelection) {
      dispatch(
        updateConfig((state) => {
          state.clearSelection = false;
        })
      );
    }
    // eslint-disable-next-line
  }, [menuState.clearSelection]);

  
  const closeModal = () => {
    dispatch(
      updateConfig((state) => {
        state.showEditModal = false;
        state.is_edit = false;
        // state.selectedItemsDetails = ""
      })
    );
  };

  const handleEditAction = (data) => {
    setSkip(() => false);
    dispatch(
      updateConfig((state) => {
        state.showEditModal = true;
        state.is_edit = true;
      })
    );
  };
  const handleEditClick = () => {
    dispatch(
      updateConfig((state) => {
        state.showEditModal = true;
        state.is_edit = true;
      })
    );
  };

  const closeEditModal = () => {
    setSkip(() => true);
    dispatch(
      updateConfig((state) => {
        state.showEditModal = false;
      })
    );
    dispatch(
      updateConfig((state) => {
        state.selectedItemsDetails = "";
      })
    );
  };

  const setStatus = (status) => {
    let data = { "id": 1, "status": status}
    updateStatus(data);
  }

  return {
    mainData,
    menuState,
    isFetching,
    isLoading,
    showEditModal,
    handleEditAction,
    refetch,
    closeModal,
    handleEditClick,
    closeEditModal,
    setStatus
  };
};

export default useHomeVideos;
